import { ReactNode } from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { tagButtonStyle } from "@/components/FinancialShared/tableStyles";

type Props = {
  nomeArquivo: string;
  url: string;
  // Linhas de detalhe (período, quantidade, validade...) abaixo do nome.
  children?: ReactNode;
};

// Bloco "Relatório gerado" dos modais de relatório (situação das parcelas e
// quitação): nome do arquivo, botão pra abrir o PDF e os detalhes do pedido.
export default function RelatorioGeradoCard({ nomeArquivo, url, children }: Props) {
  return (
    <Flex bg="green.50" borderRadius="md" p={4} borderLeftWidth="4px" borderLeftColor="green.500">
      <Flex direction="column" gap={2} w="100%" fontSize="sm">
        <Flex justifyContent="space-between" alignItems="center" gap={3}>
          <Box>
            <Text color="gray.600" fontSize="xs">Relatório gerado</Text>
            <Text fontWeight="600" wordBreak="break-all">{nomeArquivo}</Text>
          </Box>
          <Button
            size="sm"
            {...tagButtonStyle("green")}
            fontFamily="Lexend Deca"
            fontWeight="normal"
            flexShrink={0}
            onClick={() => window.open(url, "_blank", "noopener")}
          >
            Abrir PDF
          </Button>
        </Flex>
        {children}
      </Flex>
    </Flex>
  );
}
